import { createFileRoute } from '@tanstack/react-router'
import {
  useGetDefaultOrgSite,
  useSelectedOrgAndSiteInterface,
  // eslint-disable-next-line boundaries/dependencies
} from 'features/orgAndSiteSourceOfTruth'
import isNil from 'lodash/isNil'
import { AssetDatabase } from 'pages/assetDatabase/AssetDatabase'
// TODO: ARCH-529
import { assetDBSearchSchema } from 'types'

export const Route = createFileRoute('/assets/')({
  component: RouteComponent,
  staticData: {
    title: 'Assets',
  },
  validateSearch: assetDBSearchSchema,
})

function RouteComponent() {
  const searchParams = Route.useSearch()

  const { siteId, ...restOfSearchParams } = searchParams

  const defaultOrgSite = useGetDefaultOrgSite()
  const { setOrgAndSiteIds } = useSelectedOrgAndSiteInterface()

  if (!isNil(siteId)) {
    return <AssetDatabase siteID={siteId} searchParams={restOfSearchParams} />
  }

  if (defaultOrgSite.isLoading || defaultOrgSite.hasError) {
    return null
  }

  setOrgAndSiteIds(
    {
      siteId: defaultOrgSite.siteId,
      organizationId: defaultOrgSite.organizationId,
    },
    false
  )

  return (
    <>
      <AssetDatabase
        siteID={defaultOrgSite.siteId}
        searchParams={restOfSearchParams}
      />
    </>
  )
}
